import React from "react";

import Box from "veneer/Box";

import {
  ContentGroupPreviewBar,
  type PreviewMediaEntry,
} from "./ContentGroupPreviewBar";

interface ContentGroupPreviewProps {
  index?: number;
  mediaEntries?: ReadonlyArray<PreviewMediaEntry>;
  navigateTo?: (index: number) => void;
}

export function ContentGroupPreview({
  index = 0,
  mediaEntries = [],
  navigateTo = () => {},
}: ContentGroupPreviewProps) {
  const total = mediaEntries.length;

  return (
    <Box dataTestId="content-group-preview" overflow="hidden">
      <ContentGroupPreviewBar
        index={index}
        mediaEntries={mediaEntries}
        navigateTo={navigateTo}
      />
      {total > 0 && <Box textAlign="center">{`${index + 1}/${total}`}</Box>}
    </Box>
  );
}
